import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks'
import { Redirect } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading/Loading'

// material-ui
import {  IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const Logout = (props) => {
  const { t } = useTranslation()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [{ data, loading, error }, executeGet] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/user/logout`,
      method: 'GET',
      withCredentials: true,
    },
    { manual: true }
  )

  useEffect(() => { executeGet() }, [])

  const action = key => (
      <>
        <IconButton key="close" aria-label={t('snackbar.dismiss')} color="inherit" onClick={() => { closeSnackbar(key) }}>
          <CloseIcon />
        </IconButton>
      </>
  )

  useEffect(() => {
    data && enqueueSnackbar(
      t(data),
      {
        action,
        variant: 'warning',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        }
      }
    )
  }, [data])

  return data ? <Redirect to="/"/> : <Loading />
}

Logout.propTypes = {
};

export default Logout;
